import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: 15,
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  loadingSection: {
    display: 'flex',
    justifyContent: 'center',
    padding: 15,
  },
  menuBar: {
    borderTop: `1px solid ${theme.palette.primary.main}`,
    paddingTop: 16,
    paddingBottom: 16,
    cursor: 'pointer',
    marginTop: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& > p': {
      color: `${theme.palette.primary.main}`,
    },

    '&.lastItem': {
      borderBottom: 'none',
    },
  },
  divider: {
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  content: {
    paddingBottom: 5,
    '& table tr': {
      '& td:first-child': {
        paddingLeft: 0,
        '& p': {
          color:
            theme.palette.type === 'dark'
              ? '#B5E0F7'
              : theme.palette.text.primary,
        },
      },
      '& td:last-child': {
        paddingRight: 0,
      },
    },
  },
}))

export default useStyles
